import { useEffect, useRef, useState } from "react";
import { SchoolView } from "../firestore/Types/SchoolSchema";
import { getSchoolImageURL, uploadSchoolImage } from "../firebase/storage/SchoolFunction";
import { MIN_DIMENSION } from "./ImageCropper/ImageCropper";
import { CropImage } from "./ImageCropper/CropImage";

export function SchoolRow(school: SchoolView) {
    const [imageURL, setImageURL] = useState<string>("");
    const [error, setError] = useState<string>("");
    const [showCropImage, setShowCropImage] = useState<boolean>(false);

    const ImageRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        getSchoolImageURL(school.Id).then((url) => {
            setImageURL(url);
        });
    }, [school]);

    const refreshImage = async () => {
        const url = await getSchoolImageURL(school.Id);
        setImageURL(url);
    }

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.addEventListener("load", () => {
            const imageElement = new Image();
            const imageUrl = reader.result?.toString() || "";
            imageElement.src = imageUrl;

            imageElement.addEventListener("load", (e: Event) => {
                if (error) setError("");
                const { naturalWidth, naturalHeight } = e.currentTarget as HTMLImageElement;
                if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
                    setError("Image must be at least 150 x 150 pixels.");
                    return setImageURL("");
                }
            });
            setImageURL(imageUrl);
        });
        reader.readAsDataURL(file);
        if (e.target.files && e.target.files.length > 0) {
            setImageURL(e.target.files[0].name);
            setShowCropImage(true);
        }
    };

    const handleUploadImage = async (file: File) => {
        await uploadSchoolImage(school.Id, file);
        await refreshImage();
    }

    const handleCancleFileCrop = () => {
        setShowCropImage(false);
        ImageRef.current!.src = "";
    };

    return(
        <div className="flex flex-row bg-white rounded-lg border-solid border-2 m-2 p-2 border-gray-300 w-full">
            <div className="flex flex-col grow p-2">
                <div className="flex flex-row">
                    <img src={imageURL} alt="profile" className="rounded-lg w-[10%] min-w-40 m-4" />
                    <div className="flex flex-col grow gap-2">
                        <h2 className="text-2xl text-bold text-sky-500">{school.Name}</h2>
                        <div className="text-xl">{school.Address}</div>
                        <div className="text-xl">{school.FullName}</div>
                    </div>
                    <input
                        type="file"
                        accept="image/*"
                        multiple={false}
                        ref={ImageRef}
                        onChange={handleFileChange}
                        hidden
                    />
                    <button className="primary-button" onClick={() => ImageRef.current && ImageRef.current.click()} >Upload Image</button>
                </div>
            </div>
            {showCropImage && <CropImage closeModal={handleCancleFileCrop} imgSrc={imageURL} refresh={refreshImage} uploadImage={handleUploadImage}/>}
        </div>
    )
}